import React from 'react';
import PropTypes from 'prop-types';
// Revenue Hero (disabled)
// import { RevenueHero } from '@revenuehero/sdk-react';

import Heading from 'components/shared/heading';
import Button from 'components/shared/button';
// import SuccessMessage from 'components/lazy-blocks/SuccessMessage';
// import { openRevenueHeroBooking } from 'utils/open-revenue-hero-booking';
import styles from './styles.module.scss';

const ThankYou = ({
  email = '',
  phone = '',
  onDone,
  revenueheroRouterId = null, // eslint-disable-line no-unused-vars -- Revenue Hero disabled
  contactData = {}, // eslint-disable-line no-unused-vars -- Revenue Hero disabled
}) => {
  // Revenue Hero (disabled)
  // const [isMeetingScheduled, setIsMeetingScheduled] = useState(false);
  // const [isBookingBusy, setIsBookingBusy] = useState(false);

  // useEffect(() => {
  //   const handleMessage = (ev) => {
  //     if (ev.data.type === 'MEETING_BOOKED' || ev.data.type === 'MEETING_RESCHEDULED') {
  //       setIsMeetingScheduled(true);
  //       window?.scrollTo({ top: 0, behavior: 'smooth' });
  //     }
  //   };

  //   window.addEventListener('message', handleMessage);
  //   return () => window.removeEventListener('message', handleMessage);
  // }, []);

  // const openBookingModal = useCallback(() => {
  //   if (!revenueheroRouterId) {
  //     return;
  //   }

  //   setIsBookingBusy(true);
  //   openRevenueHeroBooking({
  //     routerId: revenueheroRouterId,
  //     firstname: contactData.firstName,
  //     lastname: contactData.lastName,
  //     email: contactData.email,
  //     phone: contactData.phone,
  //   })
  //     .catch((error) => {
  //       // eslint-disable-next-line no-console
  //       console.error(error);
  //     })
  //     .finally(() => {
  //       setIsBookingBusy(false);
  //     });
  // }, [revenueheroRouterId, contactData]);

  // if (isMeetingScheduled) {
  //   return (
  //     <div className={styles.thankYou}>
  //       <SuccessMessage
  //         title="Meeting Scheduled!"
  //         description="Thank you for booking a meeting with us. We've sent a confirmation email with the details."
  //         buttonLabel="Done"
  //         buttonLink="/"
  //       />
  //     </div>
  //   );
  // }

  return (
    <div className={styles.thankYou} id="estimate-submited-successfully">
      <div className={styles.successIcon}>
        <svg
          width="64"
          height="64"
          viewBox="0 0 64 64"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="32" cy="32" r="32" fill="#52C41A" fillOpacity="0.1" />
          <path
            d="M32 8C18.745 8 8 18.745 8 32s10.745 24 24 24 24-10.745 24-24S45.255 8 32 8zm0 44c-11.046 0-20-8.954-20-20S20.954 12 32 12s20 8.954 20 20-8.954 20-20 20z"
            fill="#52C41A"
          />
          <path
            d="M28.586 38.586L22.414 32.414c-.781-.781-2.047-.781-2.828 0-.781.781-.781 2.047 0 2.828l7.5 7.5c.781.781 2.047.781 2.828 0l15-15c.781-.781.781-2.047 0-2.828-.781-.781-2.047-.781-2.828 0l-13.586 13.586z"
            fill="#52C41A"
          />
        </svg>
      </div>

      <Heading className={styles.title} tag="h3" size="lg">
        Thank You!
      </Heading>

      <div className={styles.message}>
        {/* Revenue Hero (disabled): alternate copy when revenueheroRouterId was set */}
        {/* {revenueheroRouterId ? (
          <>
            <p style={{ textAlign: 'center' }}>We’ve sent your estimate by email.</p>
            <p style={{ textAlign: 'center' }}>Please select a time now.</p>
          </>
        ) : ( */}
        <>
          <p>
            Your estimate has been generated and downloaded successfully. We&apos;ve also sent a
            copy to your email address.
          </p>
          <p>
            Our team will review your project details and reach out within 24 hours to discuss your
            requirements and provide personalized support.
          </p>
        </>
        {/* )} */}
      </div>

      {/* {revenueheroRouterId && (
        <Button
          theme="accent-primary"
          onClick={openBookingModal}
          disabled={isBookingBusy}
          aria-busy={isBookingBusy}
        >
          Book a Meeting
        </Button>
      )} */}

      <div className={styles.contactInfo}>
        <p>Need help? Contact us:</p>
        <div className={styles.contactLinks}>
          <a href={`mailto:${email}`}>{email}</a>
          <span className={styles.separator}>|</span>
          <a href={`tel:${phone}`}>{phone}</a>
        </div>
      </div>
      <br />

      <Button theme="accent-primary" onClick={onDone}>
        Done
      </Button>
      {/* {revenueheroRouterId && (
        <div style={{ display: 'none' }} aria-hidden="true">
          <RevenueHero enabled routerId={String(revenueheroRouterId)} />
        </div>
      )} */}
    </div>
  );
};

ThankYou.propTypes = {
  email: PropTypes.string,
  phone: PropTypes.string,
  onDone: PropTypes.func.isRequired,
  revenueheroRouterId: PropTypes.number,
  contactData: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phone: PropTypes.string,
  }),
};

export default ThankYou;
